import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CheckoutDTO } from '../../../../shared/checkout-dto';
import { getHeaders, STORAGE_TRACK } from '../constants';
import { CustomerService } from '../customer.service';

@Injectable({
  providedIn: 'root'
})
export class BraintreeService {

  constructor(private http: HttpClient, private customerService: CustomerService) { }

  getClientToken(): Observable<any> {
    return this.http.get(`/api/payment/client_token`, { headers: getHeaders() })
  }

  checkout(total: number, purchase: CheckoutDTO, separate?: boolean, customerId?: number): Observable<any>
  {
    try
    {
      const tracking = JSON.parse(localStorage.getItem(STORAGE_TRACK) || '{}')
      return this.http.post<any>(`/api/payment/checkout`, { total, purchase, separate, customerId, tracking })
    }
    catch(e)
    {
      return this.http.post<any>(`/api/payment/checkout`, { total, purchase, separate, customerId })
    }
  }

  updateOrder(total: number, purchase: CheckoutDTO, separate?: boolean, customerId?: number): Observable<any> {
    return this.http.post<any>(`/api/payment/update`, { total, purchase, separate, customerId })
  }

  validateReCAPTCHA(token) {
    return this.http.post<any>(`/api/payment/recaptcha`, { token });
  }

  reportError(error) {
    return this.http.post<any>(`/api/declined-transaction/err`, { checkoutDTO: this.customerService.checkoutDTO, error });
  }

}
